import React from 'react';

import '@app/scss/components/switchButton.scss';

interface SwitchButtonProps<T extends Record<string, string>> {
	children: ((state: T) => React.ReactNode);
	switchOrder: Array<T>;
	index?: number;
	className?: (state) => string;
	onClick?: (state) => void;
}

const ToggleButton: React.FC<SwitchButtonProps<any>> = <T extends Record<string, string>, >(props) => {
	const {
		children,
		switchOrder,
		index = 0,
		className = () => 'switch-button',
		onClick,
	} = props;
	const [currentStateIndex, setCurrentStateIndex] = React.useState<number>(index);
	React.useEffect(() => {
		if (index !== currentStateIndex) {
			setCurrentStateIndex(index);
		}
	}, [index]);

	const handleClick: React.MouseEventHandler = (event) => {
		setCurrentStateIndex((prev) => (switchOrder.length === prev + 1 ? 0 : prev + 1));
		onClick && onClick(switchOrder[currentStateIndex]);
	};

	return (
		<button type="button" onClick={handleClick} className={className(switchOrder[currentStateIndex])}>
			{children(switchOrder[currentStateIndex])}
		</button>
	);
};

export default ToggleButton;
